module.exports = __webpack_public_path__ + "static/media/LiveReceptionist.34c2d801.svg";